import React from "react";
import { useStartGroupFreeTrialModal } from "@shared/features/bots/BotForm/common/hooks";
import Modal from "common/Modal/Modal";
import Button, { buttonStyles } from "common/Buttons/Button";
import { displayResultMessage } from "utils/misc";
import styled from "styled-components";
import ConnectGroup from "features/newMarketplace/GroupExtraDetails/JoinGroup/ConnectGroup";
import { LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface StartGroupFreeTrialModalProps {
  isOpen: boolean;
  closeModal: () => void;
  saveChanges: () => void;
}

const StartGroupFreeTrialModal = ({
  isOpen,
  closeModal,
  saveChanges,
}: StartGroupFreeTrialModalProps) => {
  const { confirmMarketplaceGroupData } = useStartGroupFreeTrialModal({
    saveChanges,
    closeModal,
    displayResultMessage,
  });
  const { t } = useTypedTranslation(LanguageNameSpaces.MARKETPLACE);

  if (!confirmMarketplaceGroupData.shouldDisplay) return null;

  const connectGroupFooter = (
    <>
      <Button onClick={confirmMarketplaceGroupData.onCancel}>Cancel</Button>
      <StyledButton
        type="primary"
        loading={confirmMarketplaceGroupData.isLoading}
        onClick={confirmMarketplaceGroupData.onOk}
        $disabled={!confirmMarketplaceGroupData.isChecked}
      >
        Save
      </StyledButton>
    </>
  );

  return (
    <Modal
      title={t("group_info.modals.start_free_trial_title")}
      open={isOpen}
      onCancel={confirmMarketplaceGroupData.onCancel}
      footer={connectGroupFooter}
      destroyOnHidden={true}
    >
      <ConnectGroup
        content={confirmMarketplaceGroupData.content}
        setIsChecked={confirmMarketplaceGroupData.setIsChecked}
        showError={confirmMarketplaceGroupData.showError}
        isHighRisk={confirmMarketplaceGroupData.isHighRisk}
      />
    </Modal>
  );
};

export default StartGroupFreeTrialModal;

const StyledButton = styled(Button)<{ $disabled: boolean }>`
  ${(p) =>
    p.$disabled &&
    `
    ${buttonStyles.antBtnDisabled};
  `}
`;
